var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('px-view-header',{attrs:{"title":"Alçadas de compra","title-class":"font-weight-bold","breadcrumbs":_vm.breadcrumbs}}),(_vm.loading)?_c('div',[_c('px-circular-loading')],1):_c('px-alcadas-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }